export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/decor-luggage.0a1007b6-563ecc.svg";